import type { TranslationSchema } from './en'

export const es: TranslationSchema = {
  game: {
    title: 'Path of Praxis',
    subtitle: 'Teorízate tu auto-battler incremental',
    deathTitle: 'Has muerto',
    deathSubtitle: 'Has ganado la siguiente experiencia y maestría para hacer tu próximo renacer más fuerte:',
    deathRebirth: 'Renacer',
    actionSelectTitle: 'Acciones',
    triggersTitle: 'Disparadores',
    triggerAutoAction: 'Ataque automático',
    actionPickerTitle: 'Elegir acción',
    legendDamage: 'Daño',
    legendSpeed: 'Velocidad',
    legendRange: 'Alcance',
    legendArea: 'Área',
    legendMana: 'Maná',
    targetingTitle: 'Prioridad de objetivo',
    targetNearest: 'Más cercano',
    targetWeakest: 'Más débil',
    targetStrongest: 'Más fuerte',
    targetRandom: 'Aleatorio',
    targetNearestDesc: 'Atacar al enemigo más cercano',
    targetWeakestDesc: 'Centrarse en PV bajos',
    targetStrongestDesc: 'Centrarse en PV altos',
    targetRandomDesc: 'Elegir objetivo al azar',
    backToMenu: 'Volver al menú',
    dieRebirth: 'Morir y renacer',
    freeRebirth: 'Renacer gratuito',
    dieConfirmTitle: '¿Morir y renacer?',
    dieConfirmBody: 'Tu partida actual terminará y se aplicarán tus maestrías. ¿Continuar?',
    dieConfirmYes: 'Morir y renacer',
    battleConfig: 'Configuración de batalla',
    masteries: 'Maestrías',
    ascentBtnLabel: 'Ascensión',
    enemyLevelLabel: 'Nivel de enemigo',
    pauseLabel: 'Pausa',
    playLabel: 'Reanudar',
    x2SpeedRemaining: 'Tiempo restante ×2',
    enemyLevelDown: 'Reducir nivel de enemigo',
    enemyLevelUp: 'Aumentar nivel de enemigo',
    autoAdvanceTitle: 'Avanzar nivel de enemigo automáticamente al desbloquear',
    autoLevelAriaLabel: 'Nivel automático de enemigos',
    autoLevelText: 'Auto',
    ascendBtn: 'Ascender a un nuevo universo',
    masteryGains: 'Ganancias de maestría',
    actionTriggerTitle: 'Disparador de acción',
    selectActionTrigger: 'Seleccionar disparador',
    slotInUse: 'Ya en uso por otro disparador',
    triggerTime: 'Disparador temporal',
    triggerTimeDesc: 'Se activa cada 2 segundos. Las acciones más rápidas infligen más daño, las más lentas menos.',
    triggerCrit: 'Disparador de golpe crítico',
    triggerCritDesc: 'Se activa cuando el ataque automático aterriza un golpe crítico. Daño base ×10 menor, equilibrado por velocidad.',
    triggerCritLock: 'Mata a un jefe con un golpe crítico',
    triggerAffliction: 'Disparador de aflicción',
    triggerAfflictionDesc: 'Se activa cada 10 aflicciones aplicadas. El daño está equilibrado por velocidad.',
    triggerAfflictionLock: 'Mata a un jefe con daño de aflicción',
    triggerMana: 'Disparador de maná',
    triggerManaDesc: 'Se activa cada 100 de maná gastado por tus acciones. El daño está equilibrado por velocidad.',
    dpsDoubleAction: 'Doble acción',
    dpsBonusTarget: 'Objetivo bonus',
    dpsExtraProjectile: 'Proyectil extra',
    dpsSplitCast: 'Lanzamiento dividido',
    dpsChainJump: 'Salto en cadena',
    dpsTremor: 'Temblor',
    dpsAfflictionBurn: 'Quemadura',
    dpsAfflictionBleed: 'Sangrado',
    dpsAfflictionGroundFire: 'Fuego en suelo',
    dpsAfflictionPoison: 'Veneno',
    dpsSplash: 'Salpicadura',
    dpsTakenHits: 'Daño recibido (golpes)',
    dpsTakenAfflictions: 'Daño recibido (aflicciones)',
    dpsAvgHitTaken: 'Golpe recibido medio',
    dpsMaxHitTaken: 'Mayor golpe recibido',
    selectAnAction: 'Seleccionar una acción',
    critLabel: 'Crítico',
  },
  mastery: {
    title: 'Maestrías',
    resetTitle: '¿Restablecer {name}?',
    confirmCancel: 'Cancelar',
    confirmReset: 'Restablecer',
    resetDescLoseLevel: 'Se eliminarán todos los nodos asignados y perderás 1 nivel en esta maestría. Los puntos convertidos se reembolsan.',
    resetDescNoLoseLevel: 'Se eliminarán todos los nodos asignados. Los puntos de maestría gratuitos y convertidos se devolverán.',
    nodeSmall: 'Nodo menor',
    nodeStrong: 'Nodo sólido',
    nodeMajor: 'Nodo mayor',
    nodeKey: 'Nodo clave',
    nodeAssigned: 'Asignado',
    nodeAssignPt: 'Asignar ({cost} pt)',
    nodeAssignPts: 'Asignar ({cost} pts)',
    nodeNeedPt: 'Necesitas {cost} punto de maestría (tienes {available})',
    nodeNeedPts: 'Necesitas {cost} puntos de maestría (tienes {available})',
    nodeKeyChosen: 'Otro nodo clave ya elegido',
    nodeNotImpl: 'Aún no implementado',
    nodeNotAvail: 'Nodo no disponible',
    resetBtn: 'Restablecer (−1 nivel)',
    dumpBtn: 'Convertir un punto',
    dumpTooltip: 'Clic: convertir 1 punto · Ctrl/Cmd+clic: convertir todos',
    dumpActivePt: 'Conversión: {dumped} pt → +{bonus}% más de {label}',
    dumpActivePts: 'Conversión: {dumped} pts → +{bonus}% más de {label}',
    dumpLabel: 'Convertir puntos para +{rate}% más de {label} por punto',
    pointsPt: 'Tienes {total} / {earned} punto de maestría para asignar{free}',
    pointsPts: 'Tienes {total} / {earned} puntos de maestría para asignar{free}',
    pointsFree: ' ({n} gratuito)',
    ctrlClickHint: 'Consejo: Ctrl/Cmd + clic en un nodo para asignar todos los puntos posibles de una vez.',
    savePlan: 'Guardar plan',
    loadPlan: 'Cargar plan',
    assignAll: 'Asignar todo',
    assignAllDump: 'Verter puntos sobrantes',
    assignAllDumpTooltip: 'Asignar todo verterá los puntos restantes en la conversión una vez completado el plan',
    slot: 'Ranura {n}',
    slotEmpty: '(vacío)',
    copyClipboard: 'Copiar al portapapeles',
    importCode: 'Importar',
    planActive: '{code}',
    planInvalid: 'Código de build inválido',
    assignAllNone: 'No hay plan cargado',
    saveNoHistory: 'El orden en que se asignaron tus nodos actuales no fue registrado. Guardar planes se desbloquea tras tu próxima Ascensión.',
    pendingGainsNote: 'El progreso mostrado en verde solo se obtendrá después de morir y renacer',
  },
  ascent: {
    title: 'Ascensión',
    ascentCount: 'Número de ascensiones: {n}',
    nextAscent: 'Próxima ascensión: nivel de enemigo {n}',
    unlockedAt: 'Desbloqueado en',
    universePoints: 'Puntos de universo',
    available: '({n} disponible)',
    removePoint: 'Quitar punto',
    addPoint: 'Añadir punto',
    threshold1: 'Golpe crítico y su maestría',
    threshold2: 'Árbol de Campeones y Jefes en la maestría enemiga',
    threshold3: '+1 ranura de disparador de acción',
    threshold4: '+1 punto de maestría gratuito por ascensión para cada maestría',
    threshold5: 'Artefactos — modificadores de riesgo/recompensa',
    threshold6: '+1 ranura de activador de acción',
    threshold7: 'Cada ascensión otorga 3 puntos de universo en vez de 2',
    threshold8: '20% más de enemigos y 20% más de experiencia de nivel de enemigo',
    threshold9: 'Equipa un segundo artefacto y lleva hasta 30 en tu bolsa',
    artifactsBtn: 'Artefactos',
    upSlotA: '10% de velocidad de multi-acción aumentada',
    upSlotB: '+1% de probabilidad base de golpe crítico de acción',
    upSlotC: '7% más de daño',
    upSlotD: '4% más de velocidad de acción',
  },
  transcend: {
    btn: 'Trascender',
    pickerTitle: 'Elige una reliquia',
    pickerHint: 'Trascender reinicia todo — incluidas las ascensiones, los puntos de universo y los artefactos no equipados. Los artefactos equipados y las reliquias permanecen. Elige tu reliquia para trascender.',
    confirmTitle: '¿Trascender?',
    confirmBody: 'Todo se reinicia — incluidas las ascensiones, los puntos de universo y los artefactos no equipados. Los artefactos equipados y las reliquias permanecen.',
    relicFreeRebirth: 'Eco de renacimiento',
    relicFreeRebirthDesc: 'Una vez por renacimiento, obtén tu progreso de maestría pendiente sin morir.',
    relicMultiAscend: 'Rompecadenas',
    relicMultiAscendDesc: 'Ascender puede otorgar varias ascensiones a la vez, hasta tu nivel máximo de enemigo −5.',
    relicExtraTrigger: 'Tercera mano',
    relicExtraTriggerDesc: 'Desbloquea una ranura de disparador de acción adicional permanente.',
    relicOnslaught: 'Embestida',
    relicOnslaughtDesc: '30% más enemigos, 10% más XP, 10% más daño.',
    powerLabel: 'Trascendencia: {n}',
    powerSummary: '+{xp}% XP · +{dmg}% daño · +{life}% vida máx',
    relicsLabel: 'Reliquias',
    ascendPlus: '{label} (+{n})',
  },
  artifacts: {
    title: 'Artefactos',
    countLabel: '{n}/{max} artefactos',
    equippedLabel: 'Equipados: {used}/{max}',
    full: 'Inventario lleno — suelta un artefacto para recibir nuevos de los jefes',
    equip: 'Equipar',
    unequip: 'Desequipar',
    bag: 'Bolsa',
    drop: 'Soltar',
    deleteBtn: 'Eliminar',
    deleteConfirmTitle: '¿Eliminar artefacto?',
    deleteConfirmBody: 'Este artefacto se perderá permanentemente.',
    deleteConfirmBtn: 'Eliminar',
    lockedHint: 'Ranuras llenas — desequipa otro artefacto primero',
    sourceFire: 'fuego',
    sourceLightning: 'rayo',
    sourcePhysical: 'físico',
    sourceCold: 'frío',
    sourceRot: 'putrefacción',
    posSourceMoreDamage: '{v}% más de daño de {source}',
    posSourceActionSpeed: '{v}% de velocidad de acción de {source} aumentada',
    posSourceAffliction: '{v}% más de efecto de aflicción de {source}',
    posGlobalActionSpeed: '{v}% más de velocidad de acción',
    posGlobalMoreDamage: '{v}% más de daño',
    posDoubleDamageChance: '+{v}% de probabilidad de doble daño',
    posDoubleActionChance: '+{v}% de probabilidad de doble acción',
    posRangeAndArea: '+{v}% de alcance y área',
    negDamageTaken: '{v}% más de daño recibido',
    negAllResistances: '-{v}% de todas las resistencias',
    negLessMoveSpeed: '-{v}% de velocidad de movimiento',
    negLessActionSpeed: '-{v}% de velocidad de acción',
    negLessRangeAndArea: '-{v}% de alcance y área',
    weightLight: 'Artefacto Ligero',
    weightMedium: 'Artefacto Medio',
    weightHeavy: 'Artefacto Pesado',
    scrapsLabel: 'Chatarra: {n}',
    upgradeBtn: 'Mejorar {scraps}/{cost}',
    upgradeResultTitle: 'Artefacto mejorado',
    upgradeMaxedTitle: 'Mejora máxima',
    upgradeMaxedBody: 'Cada línea de este artefacto ya está en su máximo — no se puede mejorar más.',
    upgradeRemovedLabel: 'Línea negativa eliminada:',
    autoDiscardLabel: 'Descartar artefactos automáticamente según la calidad:',
    autoDiscardNever: 'nunca descartar',
    autoDiscardAll: 'descartar todos',
    autoDiscardBelow: '<{v}%',
    autoDiscardDown: 'Bajar el umbral de calidad de descarte automático',
    autoDiscardUp: 'Subir el umbral de calidad de descarte automático',
    autoDiscardWeightLabel: 'o peso:',
    autoDiscardWeightAll: 'conservar todos los tamaños',
    autoDiscardWeightLight: 'descartar ligeros',
    autoDiscardWeightMedium: 'descartar medios o menos',
    autoDiscardWeightDown: 'Bajar el umbral de peso de descarte automático',
    autoDiscardWeightUp: 'Subir el umbral de peso de descarte automático',
  },
  rune: {
    addToSlot: 'Añadir runa {type} a la ranura {n}',
    clickToChange: '{label} — clic para cambiar',
    addRune: '+ Añadir runa',
    remove: 'Quitar «{label}»',
    runesTitle: 'Runas de {action}',
    runesAriaLabel: 'Runes',
    slotMinor: 'Menor',
    slotMajor: 'Mayor',
    slotKey: 'Clave',
    slotSource: 'Fuente',
    levelHint: 'Acción Nv. {level} — {unlocked}/7 ranuras desbloqueadas — +{bonus}% XP',
    selectTitle: 'Runa {type} — Ranura {n}',
  },
  menu: {
    continue: 'Continuar',
    characters: 'Personajes',
    about: 'Acerca de',
    nav: 'Menú principal',
  },
  about: {
    title: 'Acerca de Path of Praxis',
    body: 'Un auto-battler incremental de Aractis, inspirado en los RPG de acción, los juegos incrementales con prestigios multi-capa y los sistemas de recompensa basados en el uso. Este juego en fase temprana (beta) busca ofrecer una rica experiencia de theorycrafting con las mecánicas de un juego semi-idle. Por favor envía cualquier reporte, comentario o sugerencia al Discord enlazado en las opciones. ¡No olvides revisar la lista de tareas más abajo!',
    creditsTitle: 'Créditos',
    creditsAlpha: 'Gracias a N4pkin por la motivación y las pruebas alfa.',
    creditsKenneyUi: 'Paneles y botones de UI: **Kenney RPG UI Pack Extension** (CC0).',
    creditsKenneyDungeon: 'Tiles del mapa y obstáculos: **Kenney Tiny Dungeon** (CC0).',
    creditsLucide: 'Iconos: **Lucide** (licencia ISC).',
    creditsFonts: 'Tipografías: **Cinzel** y **Crimson Pro** vía Google Fonts (SIL OFL).',
    creditsClaude: 'Vibe-codeado con **Claude** (Anthropic).',
    releaseNotes: 'Notas de versión',
    releaseNotesTitle: 'Notas de versión',
    todo: 'TODO',
    todoTitle: 'TODO',
    privacy: 'Privacidad',
    privacyTitle: 'Política de privacidad',
    eula: 'EULA',
    eulaTitle: 'Acuerdo de licencia de usuario final',
  },
  terms: {
    title: 'Antes de jugar',
    intro: 'Por favor lee y acepta ambos documentos para continuar.',
    privacyLabel: 'He leído y acepto la {link}.',
    eulaLabel: 'He leído y acepto el {link}.',
    privacyLink: 'Política de privacidad',
    eulaLink: 'Acuerdo de licencia de usuario final',
    privacyTitle: 'Política de privacidad',
    eulaTitle: 'Acuerdo de licencia de usuario final',
    continue: 'Continuar',
  },
  character: {
    newTitle: 'Nuevo personaje',
    loadTitle: 'Cargar personaje',
    nameLabel: 'Nombre',
    namePlaceholder: 'Introduce un nombre…',
    create: 'Crear',
    cancel: 'Cancelar',
    current: 'Actual',
    emptySlot: '— Vacío —',
    newSlot: 'Nuevo',
    deleteLabel: 'Eliminar',
    nameTaken: 'Ese nombre ya está en uso.',
    infoTitle: 'Personaje',
    statMaxLife: 'Vida máx.',
    statMaxMana: 'Maná máx.',
  },
  settings: {
    title: 'Ajustes',
    language: 'Idioma',
    languageTitle: 'Idioma',
    hotkeysTitle: 'Atajos de teclado',
    langEn: 'Inglés',
    langFr: 'Francés',
    langEs: 'Español',
    langZh: 'Chino simplificado',
    langRu: 'Ruso',
    close: 'Cerrar',
    guide: 'Guía',
    discord: 'Discord',
    soundVolume: 'Volumen de sonido',
    soundMuted: 'Silenciar sonido',
    effectOpacity: 'Opacidad de los efectos',
    effectDetail: 'Renderizado de efectos',
    showDamageNumbers: 'Mostrar números de daño',
    showDpsMeter: 'Medidor DPS',
    fullMastery: 'Maestría completa',
    zoomLabel: 'Zoom',
    fullscreen: 'Pantalla completa',
    confirmDeath: 'Confirmar antes de la muerte manual',
    resetTutorials: 'Reiniciar tutoriales',
    saveData: 'Datos de guardado',
    saveDataDesc: 'Copia tu código de guardado para hacer una copia de seguridad o pasarlo a otro dispositivo, o pega un código abajo para restaurarlo. Importar reemplaza todos los personajes actuales.',
    exportSave: 'Copiar código de guardado',
    exportCopied: '¡Copiado!',
    importLabel: 'Pega un código de guardado',
    importPlaceholder: 'Pega aquí tu código de guardado…',
    importBtn: 'Importar',
    importError: 'Código de guardado no válido',
    importConfirmTitle: '¿Reemplazar todos los personajes?',
    importConfirmBody: 'Importar reemplazará permanentemente TODOS tus personajes existentes por los datos de guardado. Esta acción no se puede deshacer.',
    importConfirmBtn: 'Reemplazar',
    cancel: 'Cancelar',
  },
  guide: {
    title: 'Guía',
    comingSoon: 'Próximamente…',
  },
  tutorial: {
    dismiss:  'Ignorar',
    next:     'Siguiente',
    done:     'Listo',
    moreInfo: 'Más info →',
    dontShow: 'No mostrar tutoriales',
  },
  awayBonus: {
    title:   '¡Bienvenido de vuelta!',
    body:    'Estuviste ausente {away} y ganaste {earned} de tiempo a velocidad ×2.',
    close:   'Cerrar',
    watchAd: 'Ver anuncio — doblar la recompensa',
    continue: 'Continuar',
  },
  refillAd: {
    title:   'Reserva vacía',
    body:    'Tu reserva de velocidad ×2 acaba de agotarse. Mira un breve anuncio para conseguir 15 minutos.',
    watchAd: 'Ver anuncio — ganar 15 min',
    skip:    'No, gracias',
    refill:  'recargar',
  },
  masteryCategory: {
    action: 'Acción',
    damageBase: 'Base de daño',
    damageType: 'Tipo de daño',
    lifeMana: 'Vida y Maná',
    world: 'Mundo',
  },
  masteryLabel: {
    action: 'Acción',
    criticalHit: 'Golpe crítico',
    physical: 'Físico',
    fire: 'Fuego',
    lightning: 'Rayo',
    cold: 'Frío',
    rot: 'Putrefacción',
    area: 'Área',
    projectile: 'Proyectil',
    strike: 'Golpe',
    life: 'Vida',
    mana: 'Maná',
    block: 'Bloqueo',
    enemy: 'Enemigo',
    movement: 'Movimiento',
  },
  masteryTree: {
    action_0: 'Daño de acción', action_1: 'Velocidad de acción', action_2: 'Trance', action_3: 'Coste de maná',
    criticalHit_0: 'Daño crítico', criticalHit_1: 'Probabilidad crítica',
    physical_0: 'Daño físico', physical_1: 'Sangrado', physical_2: 'Ruptura de resistencia', physical_3: 'Sed de sangre',
    fire_0: 'Daño de fuego', fire_1: 'Quema', fire_2: 'Terreno en llamas', fire_3: 'Inmolación',
    lightning_0: 'Daño de rayo', lightning_1: 'Electrocución', lightning_2: 'Salto', lightning_3: 'Electrizante',
    cold_0: 'Daño de frío', cold_1: 'Escarcha', cold_2: 'Fractura', cold_3: 'Armadura helada',
    rot_0: 'Daño de putrefacción', rot_1: 'Veneno', rot_2: 'Debilitamiento', rot_3: 'Venas verdes',
    area_0: 'Daño de área', area_1: 'Tamaño de área', area_2: 'Temblor', area_3: 'Retroceso',
    projectile_0: 'Daño de proyectil', projectile_1: 'Proyectiles múltiples', projectile_2: 'Alcance de proyectil', projectile_3: 'Retroceso',
    strike_0: 'Daño de golpe', strike_1: 'Frenesí', strike_2: 'Alcance de golpe', strike_3: 'Objetivo adicional',
    life_0: 'Vida máxima', life_1: 'Resistencias', life_2: 'Regeneración de vida', life_3: 'Robo de vida',
    mana_0: 'Maná máximo', mana_1: 'Escudo de maná', mana_2: 'Regeneración de maná', mana_3: 'Robo de maná',
    block_0: 'Probabilidad de bloqueo', block_1: 'Eficiencia de bloqueo',
    enemy_0: 'Cantidad de enemigos', enemy_1: 'Calidad de enemigos', enemy_2: 'Campeones y jefes', enemy_3: 'Proliferación de enemigos',
    movement_0: 'Velocidad de movimiento', movement_1: 'Carrera', movement_2: 'Cometa',
  },
  masteryDump: {
    action: 'daño de acción', criticalHit: 'daño de golpe crítico', physical: 'daño físico',
    fire: 'daño de fuego', lightning: 'daño de rayo', cold: 'daño de frío', rot: 'daño de putrefacción', area: 'radio de acción de área',
    projectile: 'alcance de proyectil', strike: 'velocidad de acción de golpe', life: 'vida máxima',
    mana: 'maná máximo', enemy: 'enemigos invocados', movement: 'velocidad de movimiento',
    block: 'probabilidad de bloqueo',
  },
  runeLabel: {
    minorDmg: 'Daño', minorSpeed: 'Velocidad', minorMana: 'Maná', minorXp: 'Experiencia', minorAll: 'Muestrario',
    majorDmg: 'Daño', majorSpeed: 'Velocidad', majorMana: 'Maná', majorXp: 'Experiencia', majorAll: 'Muestrario',
    keySplit: 'Acción dividida', keyHeavy: 'Lento y pesado', keyManaless: 'Sin maná', keyConsequences: 'Consecuencias',
    sourceCold: 'Nevera abierta', sourceFire: 'Fogón encendido', sourceLightning: 'Matainsectos enchufado', sourcePhysical: 'Clavos derramados', sourceRot: 'Calcetines fuera',
  },
  runeDesc: {
    minorDmg: '+15% de daño de acción aumentado',
    minorSpeed: '+5% de velocidad de acción aumentada',
    minorMana: '−10% del coste de maná de acción',
    minorXp: '+20% de experiencia de acción aumentada',
    minorAll: '+3,75% daño / +1,25% velocidad / −2,5% coste de maná / +5% experiencia',
    majorDmg: '10% más de daño de acción',
    majorSpeed: '5% más de velocidad de acción',
    majorMana: '20% menos de coste de maná de acción',
    majorXp: '15% más de experiencia de acción',
    majorAll: '2,5% más de daño / 1,25% más de velocidad / 5% menos de maná / 3,75% más de experiencia',
    keySplit: '×2 de velocidad de acción — 33% menos de daño de acción',
    keyHeavy: '×2 de daño de acción — 33% menos de velocidad de acción',
    keyManaless: '×2 coste de maná — la acción se activa aunque el maná sea insuficiente',
    keyConsequences: '×2 de daño de aflicción de esta acción (sin efecto en aflicciones que no causan daño)',
    sourceCold: 'El 20% de los golpes cuentan como frío en lugar de la fuente de la acción — se aplican los efectos y la experiencia de la maestría de frío',
    sourceFire: 'El 20% de los golpes cuentan como fuego en lugar de la fuente de la acción — se aplican los efectos y la experiencia de la maestría de fuego',
    sourceLightning: 'El 20% de los golpes cuentan como rayo en lugar de la fuente de la acción — se aplican los efectos y la experiencia de la maestría de rayo',
    sourcePhysical: 'El 20% de los golpes cuentan como físico en lugar de la fuente de la acción — se aplican los efectos y la experiencia de la maestría física',
    sourceRot: 'El 20% de los golpes cuentan como podredumbre en lugar de la fuente de la acción — se aplican los efectos y la experiencia de la maestría de podredumbre',
  },
  actionLabel: {
    sword: 'Golpe de espada', bow: 'Flecha de francotirador', fireball: 'Bola de fuego', zap: 'Descarga',
    'fire-nova': 'Nova de fuego', grenade: 'Granada', 'hammer-slam': 'Golpe de martillo',
    'lightning-nova': 'Nova de rayo', bolt: 'Rayo', 'cold-nova': 'Nova de frío', 'ice-spear': 'Lanza de hielo',
    'putrid-nova': 'Nova pútrida',
    'rotten-dagger': 'Daga putrefacta',
    'poisonous-arrow': 'Flecha venenosa',
  },
  actionTag: {
    physical: 'físico', fire: 'fuego', lightning: 'rayo', cold: 'frío', rot: 'putrefacción',
    strike: 'golpe', projectile: 'proyectil', area: 'área',
  },
}
